module.exports = __webpack_public_path__ + "img/title1.9dfe8867.png";